import { Injectable } from '@angular/core';

export interface SocietyDraft {
  /** The Gesellschaft the draft belongs to (0 = new); restored only into that one. */
  societyId: number;
  formData: any;
  initialFormData: string;
}

/**
 * Keeps the unsaved "Gesellschaft erstellen" form in memory while the user creates the
 * Gesellschaftsvertrag in "Vertrag hinzufügen". In memory (not sessionStorage) because the
 * form holds picked File objects.
 */
@Injectable({ providedIn: 'root' })
export class SocietyDraftService {
  private draft: SocietyDraft | null = null;

  store(draft: SocietyDraft): void {
    this.draft = draft;
  }

  /** Returns the draft once and forgets it. */
  take(): SocietyDraft | null {
    const draft = this.draft;
    this.draft = null;
    return draft;
  }
}
